import React, { useEffect,useState } from 'react'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import { adminHeaderApi } from '../../../utils/AdminDashApi/HeaderApi'
import { BiBell } from 'react-icons/bi'
import {Row,Col,Modal} from 'react-bootstrap'
import '../../../sassFiles/sassPages/admindashboard/bill/billlallstyle.scss'
import { billCollectionApi, prevCollectionhistoryApi, searchtableApi } from '../../../utils/AdminDashApi/Bill/BillApi'
import { optionsbilltype } from '../../Helper'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';
import { HighlightRowText } from '../../../pages/adminDashboard/Bill/subComponents/HighlightRowText'
import { RxWidth } from 'react-icons/rx'
import { tr } from 'date-fns/locale'
const BillEntryNewComp = () => {


    const notification = {
        notification:true
    }
    const [searchkey,setsearchkey] = useState("")
    const [type,settype] = useState("")

    const [isAdmissionfee,setisAdmissionfee] = useState(false)
    const [isTuitionfee,setisTuitionfee] = useState(false)
    const [isBillingCharge,setisBillingCharge] = useState(false)
    const [isAnnualdevelopment,setisAnnualdevelopment] = useState(false)
    const [isAdmissionform,setisAdmissionform] = useState(false)
    const [isTextBook,setisTextBook] = useState(false)
    const [isStationary,setisStationary] = useState(false)
    const [isIdcard,setisIdcard] = useState(false)
    const [isDiary,setisDiary] = useState(false)
    const [isExerciseBook,setisExerciseBook] = useState(false)
    const [isDress,setisDress] = useState(false)
    const [isTransportation,setisTransportation] = useState(false)
    const [isITcharge,setisITcharge] = useState(false)
    const [isPicnic,setisPicnic] = useState(false)
    const [isGameCard,setisGameCard] = useState(false)
    const [isSchoolbag,setisSchoolbag] = useState(false)

    const [paymethod,setpaymethod] = useState("")
    const [selectedOption, setSelectedOptionpay] = useState('cash');
    const [cashbystudent,setcashbystudent] = useState(null)
    const [totalcollection,settotalcollection] = useState("")
    const [cardtransactionnumber,setcardtransactionnumber] = useState(null)
    const [bkashtransactionnumber,setbkashtransactionnumber] = useState(null)

    const [stuSearchInforesponse, setstuSearchInforesponse] = useState([]);
    

    const headers = {
        "X-localization": localStorage.getItem("lan"),
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Max-Age": 3600,
        "Content-Type": "application/json"
    };
    const handleClearBtn=()=>{
        setisAdmissionfee(false)
        setisTuitionfee(false)
        setisBillingCharge(false)
        setisAnnualdevelopment(false)
        setisAdmissionform(false)
        setisTextBook(false)
        setisStationary(false)
        setisIdcard(false)
        setisDiary(false)
        setisExerciseBook(false)
        setisDress(false)
        setisTransportation(false)
        setisITcharge(false)
        setisPicnic(false)
        setisGameCard(false)
        setisSchoolbag(false)
        setsearchpopulatedata({...searchpopulatedata,["headerid"]:""})
    }
    const handleCash= (e)=>{
        setSelectedOptionpay(e.target.value)
    }

    const handleCashbyStudent=(e)=>{
        setcashbystudent(e.target.value)
    }
    
    const handlecardtrxnum=(e)=>{
        setcardtransactionnumber(e.target.value)
    }
    const handlebkashtrxnum=(e)=>{
        setbkashtransactionnumber(e.target.value)
    }

    const handleChangeSchoolbag=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisSchoolbag(current => !current);
        
    }
    const handleChangeGameCard=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisGameCard(current => !current);
        
    }
    const handleChangePicnic=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisPicnic(current => !current);
        
    }
    const handleChangeITcharge=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisITcharge(current => !current);
        
    }
    const handleChangeTransportation=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisTransportation(current => !current);
        
    }
    const handleChangeDress=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisDress(current => !current);
        
    }
    const handleChangeExcerciseBook=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisExerciseBook(current => !current);
        
    }
    const handleChangediary=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisDiary(current => !current);
        
    }
    const handleChangeIdcard=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisIdcard(current => !current);
        
    }
    const handleChangestationary=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisStationary(current => !current);
        
    }
    const handleChangetextbook=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisTextBook(current => !current);
        
    }
    const handleChangeadmissionform=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisAdmissionform(current => !current);
        
    }
    const handleChangeadmission=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisAdmissionfee(current => !current);
        
    }
    const formatDate = (date) => {
      const months = [
        "JAN", "FEB", "MAR", "APR", "MAY", "JUN",
        "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"
      ];
    
      const day = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();
    
      return `${day}-${month}-${year}`;
    };
    const [studentID, setStudentId] = useState("");
    const [studentName, setStudentName] = useState("");
    const [studentClass, setStudentClass] = useState("");
    const [studentSession, setStudentSession] = useState("");
    const [studentSection, setStudentSection] = useState("");
    const [studentPeriod, setStudentPeriod] = useState("");
    const [todayDate, setTodayDate] = useState(formatDate(new Date()));
    const [previousBills, setPreviousBills] = useState([]);
    const [rcvTypes, setrcvTypes] = useState([]);
    const [myresponse, setmyresponse] = useState([]);
    
    async function fetchBillInfoes(id){
        console.log(id)
        try {
            const response = await axios.get("https://localhost:7229/api/Bill/"+ id, headers);
            console.log(response);
            setStudentId(response.data.id);
            setmyresponse(response.data);
            setStudentName(response.data.name);
            setStudentClass(response.data.class);
            setStudentSession(response.data.sessionName);
            setStudentSection(response.data.section);
            setStudentPeriod(response.data.currentPeriodName);
            setrcvTypes(response.data.rcvTypesViewModels);
            setPreviousBills(response.data.previousBills);
            //setTodayDate(new Date().toDateString("dd/MM/yyyy"));
            const foundItem = response.data.errorMsg.length > 0;
            console.log(foundItem)
            if(foundItem){
              //setsearchkey("")
              toast.error(response.data.errorMsg, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
            console.log(response.data);
            
        } catch (err) {
            if (err.response) {
                console.error(err.response.data);
                console.log(err.response.status);
                console.log(err.response.header);
            } else {
                console.error(`Error: ${err.message}`);
            }
        }
    }
    
    const handleChangetutionfee= async (event) =>{
        if (event.target.checked) {
            console.log("Ami")
            console.log(myresponse)
            await loadBillInfoToGrid(); 
          } else {
            
          }
          setisTuitionfee(current => !current);
        
    }
    const handleChangebillingcharge=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisBillingCharge(current => !current);
        
    }
    const handleChangeannualdevelopment=(event)=>{
        if (event.target.checked) {
            
          } else {
            
          }
          setisAnnualdevelopment(current => !current);
        
    }
    const [chkValue, setchkValue] = useState(0);
    const [count, setCount] = useState(1);
    const incrementCount = async () => {
      setCount(count + 1);
      console.log(selectedCheckboxes) 
      await AddMonthbtn(selectedCheckboxes, chkValue)       
    };
    const decrementCount = async () => {        
      setCount(count - 1);
      await RemoveButtonAction(selectedCheckboxes)
    };
    const handleInputSearch = (e)=>{
        setsearchkey(e.target.value)

    }
    useEffect(()=>{
    },[searchkey])

    

    
  
    //const navigate = useNavigate();

    async function SearchStudentInfo(SearchKeyWord) {
        try {
          axios.get(`https://localhost:7229/api/StudentEntry/GetStudentsInfoBySearch?searchText=${SearchKeyWord}`, headers)
          .then(function (response) {
            setstuSearchInforesponse(response.data);
            console.log(response.data)
            const foundItem = response.data.find(item => item.errorMsg.length > 0);
            console.log(foundItem)
            if(foundItem){
              setsearchkey("")
              toast.error(foundItem.errorMsg, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
          });
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
          } else {
            console.error(`Error: ${err.message}`);
          }
        }
      }
    const [billInforesponse, setbillInforesponse] = useState([]); 
    const data = {
      StuBillInfo: myresponse,
      GridAddedBill: billInforesponse.length > 0 ? billInforesponse : [{}]
    };
    async function loadBillInfoToGrid(selectedCheckboxes) {
       console.log(data)
        try {
          axios.post(`https://localhost:7229/api/Bill/RcvTypeWiseBillAddToGrid?RcvTypeId=${selectedCheckboxes}&NumberOfMonth=${count}`, data, headers)
          .then(function (response) {
            const res = response.data.filter(item => item.rcvId > 0);
            console.log(res);
            setbillInforesponse(res); 
            settotalcollection(response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.actualAmount, 0): 0 + response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.vatAmount, 0): 0 - response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.discount, 0): 0)
            //if(response.)
            console.log(response.data); 
            const foundItem = response.data.find(item => item.errorMsg.length > 0);
            console.log(foundItem)
            if(foundItem){
              toast.error(foundItem.errorMsg, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
          });
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
          } else {
            console.error(`Error: ${err.message}`);
          }
        }
      }

    async function loadPackageBillInfoToGrid(RcvTypeValue) {
      console.log(data)
        try {
          axios.post(`https://localhost:7229/api/Bill/PackageBillAddToGrid?BillRcvTypeId=${RcvTypeValue}`, data, headers)
          .then(function (response) {
            setbillInforesponse(response.data);
            settotalcollection(response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.actualAmount, 0): 0 + response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.vatAmount, 0): 0 - response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.discount, 0): 0)
            console.log(response.data);   
          });
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
          } else {
            console.error(`Error: ${err.message}`);
          }
        }
      }
    async function RemoveButtonAction(selectedCheckboxes){
      try {
        axios.post(`https://localhost:7229/api/Bill/RemoveMonthButton?BillRcvTypeIds=${selectedCheckboxes}&NumberOfMonth=${count}`, data, headers)
        .then(function (response) {
          const res = response.data.filter(item => item.rcvId > 0);
          console.log(res);
          setbillInforesponse(res); 
          settotalcollection(response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.actualAmount, 0): 0 + response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.vatAmount, 0): 0 - response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.discount, 0): 0)
          //if(response.)
          console.log(response.data); 
          const foundItem = response.data.find(item => item.errorMsg.length > 0);
          console.log(foundItem)
          if(foundItem){
            toast.error(foundItem.errorMsg, {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              });
          }
        });
      } catch (err) {
        if (err.response) {
          console.error(err.response.data);
          console.log(err.response.status);
          console.log(err.response.header);
        } else {
          console.error(`Error: ${err.message}`);
        }
      }
    }
    async function AddMonthbtn(selectedCheckboxes, chkValue) {
        try {
          axios.post(`https://localhost:7229/api/Bill/AddMonthButton?BillRcvTypeIds=${selectedCheckboxes}&NumberOfMonth=${count}&RcvTypsID=${chkValue}`, data, headers)
          .then(function (response) {
            const res = response.data.filter(item => item.rcvId > 0);
            console.log(res);
            setbillInforesponse(res); 
            settotalcollection(response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.actualAmount, 0): 0 + response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.vatAmount, 0): 0 - response.data && response.data.length > 0 ? response.data.reduce((acc, item) => acc + item.discount, 0): 0)
            //if(response.)
            console.log(response.data); 
            const foundItem = response.data.find(item => item.errorMsg.length > 0);
            console.log(foundItem)
            if(foundItem){
              toast.error(foundItem.errorMsg, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
          });
        } catch (err) {
          if (err.response) {
            console.error(err.response.data);
            console.log(err.response.status);
            console.log(err.response.header);
          } else {
            console.error(`Error: ${err.message}`);
          }
        }
      } 

    const handleSearchButton= async ()=>{
      console.log(todayDate)
      setbillInforesponse([]);
      settotalcollection(0);
      setmyresponse([]);
      await SearchStudentInfo(searchkey);
    }
    const [accountRcvresponse, setaccountRcvresponse] = useState([]);
    const drpfunctype= async (myval,myid)=>{
        settype(myid)
        try {
            const accountRCVresponse = await axios.get(
                `https://localhost:7229/api/Bill/AccountRecievableTypes?RcvTypeId=${myid}`,
                {},
                headers
            );
            setaccountRcvresponse(accountRCVresponse.data);
            
            console.log(accountRCVresponse)
        } catch (err) {
            if (err.accountRCVresponse) {
                console.error(err.accountRCVresponse.data);
                console.log(err.accountRCVresponse.status);
                console.log(err.accountRCVresponse.header);
            } else {
                console.error(`Error: ${err.message}`);
            }
        }
    }

    
    const handlePackage= async ()=>{
        // type
        
        console.log(type)
        await loadPackageBillInfoToGrid(type);
        //setisTextBook(true)
        //setisStationary(true)
    }
    const [searchpopulatedata,setsearchpopulatedata] = useState({
        headerid:"",
        id:""
    })
    const handleRowClick= async (myitem)=>{
        console.log(myitem.id)
        setsearchpopulatedata({...searchpopulatedata,["headerid"]:myitem.headerid})
        await fetchBillInfoes(myitem.id) 
        console.log("ami clicked")
        setsearchkey("")

    }
    const [billRecieveTypesresponse, setbillRecieveTypesresponse] = useState([]);
    useEffect(() => {
        const fetchBillRecieveTypesDropdown = async () => {
            try {
                const billrcvresponse = await axios.get(
                    "https://localhost:7229/api/Bill/BillRecieveTypes",
                    {},
                    headers
                );
                setbillRecieveTypesresponse(billrcvresponse.data);
            } catch (err) {
                if (err.billrcvresponse) {
                    console.error(err.billrcvresponse.data);
                    console.log(err.billrcvresponse.status);
                    console.log(err.billrcvresponse.header);
                } else {
                    console.error(`Error: ${err.message}`);
                }
            }
        };
        fetchBillRecieveTypesDropdown();
    }, []);
    const [afterBillSaveResponse, setafterBillSaveResponse] = useState([]);
    const handleSave= async ()=>{
      console.log(cardtransactionnumber);
      await SaveBill(selectedOption, cashbystudent)
    }
    async function SaveBill(payementoption, CashFromStu) {
      console.log(data)
       try {
         axios.post(`https://localhost:7229/api/Bill/SaveButtonAction?PaymentMethod=${payementoption}&TransactionID=${cardtransactionnumber}&cashbystudent=${CashFromStu}&Billdate=${todayDate}`, data, headers)
         .then(function (response) {
            console.log(response.data);
            setafterBillSaveResponse(response.data)
            setPreviousBills(response.data.item2);
            const foundSussess = response.data.item2.find(item => item.successMsg.length > 0);
            const foundError = response.data.item2.find(item => item.errorMsg.length > 0);
            console.log(foundError)
            console.log(foundSussess)
            if(foundSussess){
              toast.success(foundSussess.successMsg, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
            else if(foundError){
              toast.error(foundError.errorMsg, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
            }
         });
       } catch (err) {
         if (err.response) {
           console.error(err.response.data);
           console.log(err.response.status);
           console.log(err.response.header);
         } else {
           console.error(`Error: ${err.message}`);
         }
       }
     }
    const [showmodal,setshowmodal] = useState(false)
    const handleClose = ()=>{
        setshowmodal(false)
    }
    const handlepreviewmodal=()=>{
        setshowmodal(true)
    }

    const [screenSize, getDimension] = useState({
        dynamicWidth: window.innerWidth,
        dynamicHeight: window.innerHeight
      });
      const setDimension = () => {
        getDimension({
          dynamicWidth: window.innerWidth,
          dynamicHeight: window.innerHeight
        })
      }
      
      useEffect(() => {
        window.addEventListener('resize', setDimension);
        
        return(() => {
            window.removeEventListener('resize', setDimension);
            
        })
      }, [screenSize])

       const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
       const handleCheckboxChange = async (event) => {
        const checkboxValue = event.target.value;
        setchkValue(checkboxValue)
        console.log(event.target.value)
        console.log(checkboxValue)
        setSelectedCheckboxes([...selectedCheckboxes, checkboxValue]);
        await loadBillInfoToGrid(event.target.value)
        }
         
      
  //start
  return (
    <>
      <div className="f-flex flexvaluecomp">
        <SidebarOfAdash />

        <div
          className="contentpartwidthwrapper"
          style={screenSize.dynamicHeight < 925 ? { marginBottom: "75px" } : {}}
        >
          <div className="headerofadash billpart">
            <div className="left">
              <div className="leftsidesearch">
                <input
                  type="text"
                  value={searchkey}
                  onChange={handleInputSearch}
                  name="searchword"
                  placeholder="Search Student"
                />
                <span onClick={handleSearchButton}>
                  <img
                    src="./assets/images/dashboards/adminDashboard/bill/searchbutton.png"
                    alt=""
                  />
                </span>
                <div
                  style={{ width: "700px" }}
                  className={
                    searchkey
                      ? "searchtable d-block"
                      : "searchtable d-none"
                  }
                >
                  <div className="wrapper">
                    <div className="billentrytoptable searchtablediv">
                      <table>
                        <thead>
                          <tr>
                            {searchtableApi.heading.map((item, key) => {
                              return <th key={key}>{item.head}</th>;
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          {stuSearchInforesponse 
                            ? stuSearchInforesponse.map((item, key) => {
                                return (
                                  <tr
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleRowClick(item)}
                                  >
                                    <td>{item.studentHeaderId>0 ? item.studentHeaderId : ""}</td>
                                    <td>{item.id}</td>
                                    {
                                      stuSearchInforesponse.studentHeaderId>0?
                                      <HighlightRowText
                                      text={item.name}
                                      searchText={searchkey}
                                    />
                                      :
                                      ""
                                    }
                                    
                                    <td>{item.name}</td>
                                    <td>{item.className}</td>
                                    <td>{item.section}</td>
                                    <td>{item.status}</td>
                                  </tr>
                                );
                              })
                            : ""}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="right">
              {notification.notification == true ? (
                <div className="belldiv">
                  <BiBell />
                </div>
              ) : (
                <BiBell />
              )}
              <div className="displaypic">
                <img
                  src="./assets/images/dashboards/adminDashboard/header/DP.png"
                  alt=""
                />
              </div>
              <div className="nameandid">
                <h5>{adminHeaderApi.name}</h5>
                <p>ID {adminHeaderApi.id}</p>
              </div>
            </div>
          </div>

          <div className=" contentflexvalue billcontent">
            <Row>
              <Col lg={5} className="pd15">
                <div className="smallheader d-flex">
                  <img
                    src="./assets/images/dashboards/adminDashboard/bill/smheadinfo.png"
                    alt=""
                  />
                  <h4>Basic Information</h4>
                </div>
                <div className="billbox small">
                  <div className="myrow">
                    <div className="left">
                      <p>Name</p>
                    </div>
                    <div className="right">
                      <input type="text" value={studentName} disabled />
                    </div>
                  </div>
                  <div className="twodivide">
                    <div className="commonfifty">
                      <div className="myrow">
                        <div className="left">
                          <p>ID</p>
                        </div>
                        <div className="right">
                          <input type="text" value={studentID} disabled />
                          {/* <input type="text" value={searchpopulatedata.headerid?searchpopulatedata.headerid:""} disabled/> */}
                        </div>
                      </div>
                    </div>
                    <div className="commonfifty">
                      <div className="myrow">
                        <div className="left">
                          <p>Section</p>
                        </div>
                        <div className="right">
                          <input type="text" value={studentSection} disabled />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="twodivide">
                    <div className="commonfifty">
                      <div className="myrow">
                        <div className="left">
                          <p>Class</p>
                        </div>
                        <div className="right">
                          <input type="text" value={studentClass} disabled />
                        </div>
                      </div>
                    </div>
                    <div className="commonfifty">
                      <div className="myrow">
                        <div className="left">
                          <p>Session</p>
                        </div>
                        <div className="right">
                          <input type="text" value={studentSession} disabled />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="twodivide">
                    <div className="commonfifty">
                      <div className="myrow">
                        <div className="left">
                          <p>C. Period</p>
                        </div>
                        <div className="right">
                          <input type="text" value={studentPeriod} disabled />
                        </div>
                      </div>
                    </div>
                    <div className="commonfifty">
                      <div className="myrow">
                        <div className="left">
                          <p>Date</p>
                        </div>
                        <div className="right">
                          <input type="text" value={todayDate} disabled />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="smallheader d-flex">
                  <img
                    src="./assets/images/dashboards/adminDashboard/bill/smprev.png"
                    alt=""
                  />
                  <h4>Previous Collection History</h4>
                </div>

                <div className="billbox medium">
                  <div className="wrapper">
                    <div className="billentrytoptable previouscollectiontable prevtableori">
                      <table>
                        <thead>
                          <tr>
                            {prevCollectionhistoryApi.heading.map(
                              (item, key) => {
                                return <th key={key}>{item.head}</th>;
                              }
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {previousBills && previousBills.length > 0
                            ? previousBills.map((item, key) => (
                                <tr key={key}>
                                  <td>{item.billNo}</td>
                                  <td>{item.billDate}</td>
                                  <td>{`${item.rcvType}`}</td>
                                  <td>{item.period}</td>
                                  <td>{item.rcvAmount}</td>
                                </tr>
                              ))
                            : prevCollectionhistoryApi.data.map(
                                (item2, key2) => {
                                  return (
                                    <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  );
                                }
                              )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="totalsum">
                    <h5>Total : {previousBills && previousBills.length > 0 ? previousBills.reduce((acc, item) => acc + item.rcvAmount, 0) : "00.00"}</h5>
                  </div>
                </div>
              </Col>
              <Col lg={7} className="ps-0">
                <div className="smallheader d-flex">
                  <img
                    src="./assets/images/dashboards/adminDashboard/bill/billcollection.png"
                    alt=""
                  />
                  <h4>Bill Collection</h4>
                </div>
                <div className="billbox billcollection">
                  <div className="mybuttons">
                    <Dropdown2
                      func={drpfunctype}
                      myplaceholder="Select Type"
                      fontsize="12"
                      fontfamily="'Poppins', sans-serif"
                      options={billRecieveTypesresponse}
                    />

                    <button onClick={handlePackage}>Package</button>

                    <div className="basicinfopopulatebillentry basicinfopopulatebillentryincdec">
                      <input
                        type="text"
                        name="countnumber"
                        placeholder={count}
                        value={`Month ${count}`}
                      />
                      <div className="plus" onClick={incrementCount}>
                        +
                      </div>
                      <div className="minus" onClick={decrementCount}>
                        -
                      </div>
                    </div>

                    <button className="rightbutton ms-auto">
                      Collect Previous Due
                    </button>
                  </div>
                  <div className="radiobuttons">
                    <div className="titlewithwhite">
                      <p>All Receive Types</p>
                    </div>
                    <div className='d-flex flex-wrap'>

                    {accountRcvresponse && accountRcvresponse.map((item, key) => {
                      return (
                        <div className="checkboxfull">
                          <input
                            type="checkbox"
                            value={item.id}
                            onChange={handleCheckboxChange}
                            id="remember"
                            name="subscribe"
                            checked={billInforesponse ? (billInforesponse.find((temp) => temp.rcvId === item.id) ? true : false) : item.id}
                          />
                          <span>{item.opt}</span>
                        </div>
                      );
                    })}
                    </div>

                  </div>
                  <div className="billbox billcollectionbox">
                    <div className="wrapperbillcollection">
                      <div className="billentrytoptable billCollectiontable">
                        <table>
                          <thead>
                            <tr>
                              {billCollectionApi.heading.map((item, key) => {
                                return <th key={key}>{item.head}</th>;
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            {billInforesponse.map((item, key) => {
                              return (
                                <tr>
                                  <td>{item.sl}</td>
                                  <td>{item.rcvType}</td>
                                  <td>{item.billAmount}</td>
                                  <td>{item.actualAmount}</td>
                                  <td>{item.discount}</td>
                                  <td>{item.vatAmount}</td>
                                  <td>{(item.actualAmount+item.vatAmount)-item.discount}</td>
                                  <td>{item.period}</td>
                                  <td>{item.remarks}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="clocluwrap d-flex">
                      <div className="basicinput conclusionboxes">
                        <p>Total Bill</p>
                        <input type="text" value={billInforesponse && billInforesponse.length > 0 ? billInforesponse.reduce((acc, item) => acc + item.actualAmount, 0): 0} disabled />
                      </div>
                      <div className="basicinput conclusionboxes">
                        <p>Total Vat</p>
                        <input type="text" value={billInforesponse && billInforesponse.length > 0 ? billInforesponse.reduce((acc, item) => acc + item.vatAmount, 0): 0} disabled />
                      </div>
                      <div className="basicinput conclusionboxes">
                        <p>Total Discount</p>
                        <input type="text" value={billInforesponse && billInforesponse.length > 0 ? billInforesponse.reduce((acc, item) => acc + item.discount, 0): 0} disabled />
                      </div>
                      <div className="basicinput conclusionboxes">
                        <p>Total Collection</p>
                        <input type="text" value={totalcollection} disabled />
                      </div>
                    </div>
                  </div>
                  <div className="billbox paymentcollectbox">
                    <div className="titlewithwhite">
                      <p>Payment Collect</p>
                    </div>

                    <div className="paymentmethodpart">
                      <div className="selectionpart">
                        <p>Payment Method</p>
                        <input
                          type="radio"
                          value="cash"
                          checked={selectedOption === "cash"}
                          onChange={handleCash}
                        />
                        <label>Cash</label>
                        <input
                          type="radio"
                          value="card"
                          checked={selectedOption === "card"}
                          onChange={handleCash}
                        />
                        <label>Card</label>
                        <input
                          type="radio"
                          value="bkash"
                          checked={selectedOption === "bkash"}
                          onChange={handleCash}
                        />
                        <label>BKash</label>
                      </div>
                      {selectedOption == "cash" ? (
                        <div className="clocluwrap d-flex">
                          <div className="basicinput conclusionboxes">
                            <p>Cash By Student</p>
                            <input
                              type="text"
                              value={cashbystudent}
                              onChange={handleCashbyStudent}
                            />
                          </div>
                          <div className="basicinput conclusionboxes">
                            <p>Return Amount</p>
                            <input
                              type="text"
                              value={
                                cashbystudent
                                  ? cashbystudent - totalcollection
                                  : 0
                              }
                              disabled
                            />
                          </div>
                          <div className="basicinput conclusionboxes">
                            <p>Bill Number</p>
                            <input
                              className="twice"
                              type="text"
                              value={afterBillSaveResponse? afterBillSaveResponse.item1 : ""}
                              disabled
                            />
                          </div>
                        </div>
                      ) : selectedOption == "card" &&
                        selectedOption !== "bkash" ? (
                        <div className="clocluwrap d-flex">
                          <div className="basicinput conclusionboxes">
                            <p>Transaction Number</p>
                            <input
                              type="text"
                              className="twice"
                              value={cardtransactionnumber}
                              onChange={handlecardtrxnum}
                            />
                          </div>
                          <div className="basicinput conclusionboxes">
                            <p>Bill Number</p>
                            <input
                              className="twice"
                              type="text"
                              value="130"
                              disabled
                            />
                          </div>
                        </div>
                      ) : selectedOption == "bkash" &&
                        selectedOption !== "card" ? (
                        <div className="clocluwrap d-flex">
                          <div className="basicinput conclusionboxes">
                            <p>Transaction Number(bkash)</p>
                            <input
                              type="text"
                              className="twice"
                              value={bkashtransactionnumber}
                              onChange={handlebkashtrxnum}
                            />
                          </div>
                          <div className="basicinput conclusionboxes">
                            <p>Bill Number</p>
                            <input
                              className="twice"
                              type="text"
                              value="130"
                              disabled
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <div className="bottombarofsave">
              <div className="wrapper">
                <button onClick={handleClearBtn}>Clear</button>
                <button onClick={handlepreviewmodal}>Preview</button>
                <button onClick={handleSave}>Save</button>
                <button>Save & Print</button>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        {/* Same as */}
        <ToastContainer />
        <Modal
          dialogClassName="mymodalpreview"
          show={showmodal}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title className="me-auto" style={{ marginLeft: "50px" }}>
              Preview
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="wrapperbillcollection">
              <div className="billentrytoptable billCollectiontable previewmodaltable">
                <table>
                  <thead>
                    <tr>
                      {billCollectionApi.heading.map((item, key) => {
                        return <th key={key}>{item.head}</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {billInforesponse.map((item, key) => {
                      return (
                        <tr>
                          <td>{item.sl}</td>
                          <td>{item.rcvType}</td>
                          <td>{item.billAmount}</td>
                          <td>{item.actualAmount}</td>
                          <td>{item.discount}</td>
                          <td>{item.vatAmount}</td>
                          <td>{(item.actualAmount+item.vatAmount)-item.discount}</td>
                          <td>{item.period}</td>
                          <td>{item.remarks}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default BillEntryNewComp